import { directus } from '../../../../utilities/directus';

const filesRequest = async() => {

	const response = {};

	await directus.items('directus_files').readByQuery({limit: -1, meta: '*'}).then((data) => {
		if(!data.data) return;

		data.data.map((value) => {
			if(!value || !value.id) return;
			response[value.id] = value;
		});
	});

	return {
		response : response,
		collection: 'files'
	};
};

export default filesRequest;